import React from "react";
import * as modalDataService from "./modalDataService";
import { debug } from "../../utils";
import { connect } from "react-redux";
import EnablePasswordTextField from "./EnablePasswordTextField";

function EnablePasswordField({ hasEnabledPassword }) {

    const onChange = (value) => { modalDataService.changeEnablePassword(value); }

    return (
        <div className="form-group modal-v2-enable-password-group">
            <div className="modal-v2-enable-password-heading">Enable Password</div>
            <div className="oct_check modal-v2-enable-password-check-v2">
                <label className="oct_check-label">
                    <input type="checkbox" checked={!!hasEnabledPassword} onChange={() => {
                        //setShow(!showPasswordTextField); 
                        onChange(!hasEnabledPassword);
                    }} />
                    <span>Has Enable Password</span>
                </label>
            </div>
            {/* { showPasswordTextField ? <EnablePasswordTextField/> : null } */}
            {hasEnabledPassword ? <EnablePasswordTextField /> : null}
        </div>
    )

}

function mapStateToProps(state) {
    debug("EnablePasswordField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        hasEnabledPassword: addDeviceModal.hasEnabledPassword || ''
    }
}

export default connect(mapStateToProps)(EnablePasswordField);
